import { defineComponent, PropType } from 'vue'
import './index.scss'
import gsap from 'gsap'
import { ModuleBase, GfrToast } from '#components'
import { moduleBaseProps } from '@/components/module/base'
type ModulePreregisterType = 'default' | 'ua'
interface DownloadConfig {
  img: string
  url: string
}

export default defineComponent({
  name: 'ModulePreregister',
  props: {
    ...moduleBaseProps,
    type: {
      type: String as PropType<ModulePreregisterType>,
      default: 'default'
    },
    logo: String,
    titleImage: String,
    description: String,
    slogan: String,
    trailer: String,
    download: Array as PropType<DownloadConfig[]>,
    preregisterPolicy: String,
    requiredPhone: Number,
    openPhone: Number,
    uaBackgroundOne: String,
    uaBackgroundTwo: String,
    className: null as unknown as PropType<unknown>
  },
  emits: ['complete'],
  setup(props, { slots, emit }) {
    const store = useStore()
    const { toast } = storeToRefs(store)
    const main = ref()
    const description = computed(() => props.description)
    let ctx: any
    onMounted(() => {
      ctx = gsap.context((self) => {
        const title = self.selector && self.selector('.anime-title')
        const slogan = self.selector && self.selector('.anime-slogan')
        const link = self.selector && self.selector('.anime-link')
        gsap
          .timeline({
            onComplete: () => emit('complete')
          })
          .fromTo(title, { opacity: 0, y: 90 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power4' }, 0.15)
          .fromTo(slogan, { opacity: 0, y: 80 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power4' }, 0.3)
          .fromTo(link, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power4' }, 0.7)
      }, main.value)
    })
    onUnmounted(() => {
      ctx.revert() // <- Easy Cleanup!
    })
    return () => (
      <ModuleBase
        name={props.name}
        className={props.className}
        hasVideo={props.video !== ''}
        video={props.video}
        desktopBackground={props.desktopBackground}
        mobileBackground={props.mobileBackground}
        videoPoster={props.desktopBackground}
      >
        <section ref={main} class={['module-preregister', props.type]}>
          <div class="module-preregister-brand">
            {props.titleImage && (
              <picture class={['module-preregister-title', 'anime-title']}>
                <img class="module-preregister-title-img" src={props.titleImage} alt={props.name} />
              </picture>
            )}
            {description.value && <p class={'module-preregister-slogan anime-slogan'}>{description.value}</p>}
          </div>
          {props.download && props.download.length > 0 && (
            <div class={['module-preregister-links', `anime-link`, props.type]}>
              <div class={['module-preregister-download', props.type]}>
                {props.download?.map((item) => (
                  <a class={['module-preregister-link']} href={item.url} target="_blank">
                    <img class="module-preregister-line-img" src={item.img} alt={props.name} />
                  </a>
                ))}
              </div>
            </div>
          )}
          <GfrToast
            show={toast.value.show}
            duration={toast.value.duration}
            message={toast.value.message}
            closeOnClick={toast.value.closeOnClick}
            onUpdate:show={(val) => (toast.value.show = val)}
          />
          {slots.default?.()}
        </section>
      </ModuleBase>
    )
  }
})
